import { isEnokiWallet } from '@mysten/enoki';
import { useCurrentAccount, useCurrentWallet } from '@mysten/dapp-kit';
import type { WalletAccount, WalletWithRequiredFeatures } from '@mysten/wallet-standard';
import type { AuthType } from '../types/auth-type.type';
import { WalletProvider } from '../types/wallet-provider.type';
import { useSuiWallet } from './useSuiWallet';
import { useZkLoginWallet } from './useZkLoginWallet';
import { useWalletType } from './useWalletType';

type WalletConnection = {
	wallet: WalletWithRequiredFeatures | null;
	account: WalletAccount | null;
	authType: AuthType;
	walletProvider: WalletProvider | null;
};

export function useCurrentConnection(): WalletConnection {
	const { currentWallet: sdkWallet } = useCurrentWallet();
	const sdkAccount = useCurrentAccount();
	const suiWalletSlice = useSuiWallet();
	const zkLoginWalletSlice = useZkLoginWallet();
	const { activeWalletType } = useWalletType();

	const activeSlice = activeWalletType === 'zkLoginWallet' ? zkLoginWalletSlice : activeWalletType === 'suiWallet' ? suiWalletSlice : null;

	const currentWallet = activeSlice?.currentWallet ?? sdkWallet ?? null;
	const currentAccount = activeSlice?.currentAccount ?? sdkAccount ?? null;

	const authType: AuthType = currentWallet ? (isEnokiWallet(currentWallet) ? 'zklogin' : 'wallet') : null;
	const walletProvider: WalletProvider | null = currentWallet
		? isEnokiWallet(currentWallet)
			? (currentWallet.provider.toLowerCase() as WalletProvider)
			: (currentWallet.name.toLowerCase() as WalletProvider)
		: null;

	return {
		wallet: currentWallet,
		account: currentAccount,
		authType,
		walletProvider,
	};
}
